require.register("app/product/show/PriceTab", function(exports, require, module){
  $0
  
});

